const messages = {
    "setting.dashboard.title": "تنظیمات سیستم",
    

    "setting.field.name":"نام فیلد",
    "setting.field.type":"نوع فیلد",
    "setting.field.category":"دسته بندی",
    "setting.field.category.new":"دسته بندی جدید",
    "setting.field.state":"وضعیت نمایش فیلد",
    "setting.field.new":"افزودن فیلد جدید",
    "setting.field.edit":"ویرایش فیلد",
    "setting.field.save":"ثبت فیلد",
    "setting.field.values":"مقادیر فیلد",


    "setting.account.form":"تنظیمات فرم طرف حساب",
    "setting.user.introduction":"تنظیمات فرم نحوه آشنایی",

};

export default messages;
